import { generatePath } from "react-router-dom";
import qs from "query-string";
import { filterObject } from "@/utils";

type tArgs = {
  params?: Maybe<{
    loc?: string;
    spec?: string;
  }>;
  query?: tAnyDict & {
    spec?: string;
    address_label?: string;
    lat?: string | number;
    lng?: string | number;
  };
};
const generator = ({ params, query: rawQuery }: tArgs) => {
  const query: tArgs["query"] = filterObject(
    rawQuery,
    (key: boolean | string) =>
      key !== undefined && key !== false && key !== "false" && key !== ""
  );
  let url;
  // https://trello.com/c/CJ0S8kRN
  let finalQuery = { ...query, id: undefined };
  if (params?.loc) {
    delete finalQuery.address_label;
    delete finalQuery.lat;
    delete finalQuery.lng;
    url = generatePath("/search/:loc/:spec?", {
      loc: params.loc,
      spec: params.spec || finalQuery.spec,
    });
    delete finalQuery.spec;
  } else {
    url = "/search";
  }
  return qs.stringifyUrl({
    url,
    query: finalQuery,
  });
};
export const useSearchUrlGenerator = () => generator;
